import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import Eatec from "../../../assets/img/Featured/tablet-eatec.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const ShippingPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page shippingPage">
        <Header />
        <div className="page-header">Business & Industry Dining</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Shipping & Receiving</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Don't let unexpected food costs eat away at your 
            profits. Manage inventory on-hand by freshness, 
            warehouse, location and venue, as well as 
            automated replenishment requisitions to optimize 
            availability.{'\n\n'}

            Eatec Mobile speeds receiving and stock 
            movements so every inquiry is accurate and each 
            ingredient is where you need it when you need it.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Business & Industry Dining - Shipping & Receiving", "Eatec");
              addFlow("Eatec");
              navigate("/solutions/eatec");
            }}
          >
            <div className="item-head">
              <LogoMini />
              Eatec
            </div>
            <img src={Eatec} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default ShippingPage;